export const RRS_COMPARE_CONSUMER_LOANS = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Sammenligne forbrukslån? Så enkelt sparer du tid og penger! ',
  url: 'https://scoopr.no/sammenlign-forbrukslan',
  description:
    'Når du skal søke om forbrukslån bruker du mindre tid om du sender én søknad til sammenligningstjenesten Scoopr. Og siden vi sender søknaden din videre til 13 banker, er sannsynligheten stor for at du sparer penger også. Mye penger.',
  datePublished: '2022-02-03T08:00:00+00:00',
  dateModified: '2022-02-03T08:00:00+00:00',
};
